import { bindable, useView } from 'aurelia-templating';
import { bindingMode } from 'aurelia-binding';
import { inject } from 'aurelia-dependency-injection';
import { PLATFORM } from 'aurelia-framework';
import IconMap from './comp-icon-map';

//Load styles
require("./comp-icon.scss");

@inject(Element)
@useView(PLATFORM.moduleName("./comp-icon.html"))
export class CompIcon {

	@bindable({ defaultBindingMode: bindingMode.twoWay })
	public icon: any = undefined;

	constructor(private element: HTMLElement) { }

	public bind() {
		if (this.icon) {
			this.changeIcon(this.icon);
		}
	}

	public iconChanged(newValue: any) {
		this.changeIcon(newValue);
	}

	private changeIcon(icon: string) {
		const iconSet = IconMap.Map.find(set => set.name === icon);

		if (iconSet) {
			this.element.innerHTML = iconSet.value;
		}
	}
}
